import React from 'react'
import { ForEachModel, useValue } from '@morningtrain/react-resources'
import { Currency } from 'support/displays'
import { useEnvValue } from '@morningtrain/react-helpers'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'

export default function OrderCategoryPriceSummary ({ children }) {
  const items = useValue('collection')
  const [orderItems] = useEnvValue('globals.inventory.order_items', {})

  function summarize () {
    let amount = 0
    items.forEach(item => {
      const orderItem = orderItems[item.get('id')]
      if (orderItem) {
        amount += orderItem.total_price
      }
    })
    return amount
  }

  const [summary, setSummary] = React.useState(summarize())

  React.useEffect(() => {
    const nextSummary = summarize()

    if (nextSummary !== summary) {
      setSummary(nextSummary)
    }
  }, [items])

  if (items.length === 0) {
    return null
  }

  return (
    <div className='space-y-4 flex flex-col'>
      <UI.SpaceBetween>
        <UI.Text weight='medium'>
          <UI.WithSubtitle subtitle={<Translation name='partials.items_count' data={{ amount: items.length }} />}>
            <Displays.Text name='key' />
          </UI.WithSubtitle>
        </UI.Text>
        <UI.Text weight='medium' align='right'>
          <UI.WithSubtitle subtitle={<Translation name='partials.order_value' />}>
            <Currency defaultValue={summary} />
          </UI.WithSubtitle>
        </UI.Text>
      </UI.SpaceBetween>
      {children}
    </div>
  )
}
